// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio {
    padding-bottom: 1.25em;
}

.radio > *{
    margin-right: 7px;
}

.vcenter {
    align-self: center;
}

.addParam {
    justify-content: flex-end;
}

.textWrap {
    white-space: pre-wrap;
}`, "",{"version":3,"sources":["webpack://./src/app/workflow/modules/dataoperations/datasource/datasource.settings.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".radio {\n    padding-bottom: 1.25em;\n}\n\n.radio > *{\n    margin-right: 7px;\n}\n\n.vcenter {\n    align-self: center;\n}\n\n.addParam {\n    justify-content: flex-end;\n}\n\n.textWrap {\n    white-space: pre-wrap;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
